/* eslint-disable @typescript-eslint/no-empty-function */
import { CloseIcon } from 'assets/icons/CloseIcon'
import { DashboardCard, P } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { WidgetHeader, WidgetTitle } from './widgetParts.styled'
import { WidgetBody } from '../hrLayout.styled'
import { HrWidgetBody } from './HrWidgetBody'

export const HrFoodOperationsWidget = ({ modalOpen, removeWidget, onDragOver, onDragStart, onDragDrop }: IWidget) => {
  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => onDragStart('food', 1)}
      onDrop={onDragDrop}
      onDragEnd={(e) => e.preventDefault()}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('food')
      }}
      width='1fr'
      style={{ gridArea: 'food', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('food')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <WidgetHeader>
        <WidgetTitle>Food Operations</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <HrWidgetBody type='food' />
      </WidgetBody>
    </DashboardCard>
  )
}
